import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { Auth } from '../model/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Permission, Token } from '../model/token';
import { jwtDecode } from "jwt-decode";
import { environment } from 'src/environments/environment';
import { NdgService } from './ndg.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<Auth>;

  constructor(
    private http: HttpClient,
    private ndgService: NdgService
  ) {
    this.currentUserSubject = new BehaviorSubject<Auth>(JSON.parse(localStorage.getItem('currentUser') || "{}"));
  }
  
  public get currentUserValue(): Auth {
    return this.currentUserSubject.value;
  }
  
  public isLoggedIn(): boolean {
    const currentUser = this.currentUserValue;
    return !!currentUser && !!currentUser.token;
  }

  public hasAuthority(authority: Permission): boolean {
    if(this.isLoggedIn()) {
      const tokenPayload: Token = jwtDecode(JSON.stringify(this.currentUserValue.token));
      return tokenPayload.auth.indexOf(authority) > -1;
    }
    
    return false;
  }

  authenticate(username: string, password: string): Observable<Auth> {
    return this.http.post<Auth>(environment.api.auth, { username, password })
    .pipe(
      map((data: Auth) => {
          if (data.token !== null) {
            localStorage.setItem('currentUser', JSON.stringify(data));
            this.currentUserSubject.next(data);
          }

          return data;
        }
      )
    );
  }

  authenticateExternal(token: string): Observable<Auth> {
    this.logout();
    const headers = new HttpHeaders({'Authorization': 'Bearer ' + token});

    return this.http.post<Auth>(environment.api.auth + '/external', null, { headers })
    .pipe(
      map((data: Auth) => {
        localStorage.setItem('currentUser', JSON.stringify(data));
        this.currentUserSubject.next(data);

        return data;
      }),
      catchError(
        (e: any) => {
          throw e;
        }
      )
    );
  }

  resetPassword(usernameOrEmail: string): Observable<void> {
    return this.http.post<void>(environment.api.public + '/reset-password', { usernameOrEmail });
  }

  changePassword(username: string, password: string, newPassword: string): Observable<void> {
    return this.http.post<void>(environment.api.public + '/change-password', { username, password, newPassword });
  }

  logout() {
    this.ndgService.resetNdg();
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next({} as Auth);
  }
}
